import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { EnvelopeCheck } from "react-bootstrap-icons";
import { useLocation, useNavigate } from "react-router-dom";
import * as Actions from "../../../constants/baseUrl";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ConfirmEmail = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const emailParam = query.get("email") || "";
    // Replace any spaces that may have been introduced in email containing '+'
    setEmail(emailParam?.replace(/\s+/g, "+"));
    setToken(query.get("token") || "");
  }, [query]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${Actions.AUTH_URL}/Users/confirm-email`, {
        email,
        token,
      });
      setSuccess(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(
        err.response?.data?.message || "Confirmation failed. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="my-5 pt-5 demosAddFormSection">
      <div className="formWrap row mx-0 mt-5">
        <form
          onSubmit={handleSubmit}
          className="col-lg-6 col-md-10 demosAddForm"
        >
          <div className="col-12 demosAddFormHeasder text-center py-3">
            <EnvelopeCheck className="display-2 theme-text" />
            <h3 className="addFormHeading">You are all set!</h3>
            <h6 className="theme-text-2">
              Please click button below to confirm your email address.
            </h6>
          </div>
          <p className="text-center">{email}</p>
          {error && <div className="alert alert-danger mx-2">{error}</div>}
          {success && (
            <div className="alert alert-success mx-2">
              Email confirmed! Redirecting to login...
            </div>
          )}
          <Button
            className="btn add-button px-4 d-block mb-3 mx-auto"
            type="submit"
            disabled={loading || !email || !token || success}
          >
            {loading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              "Confirm Email"
            )}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ConfirmEmail;
